"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("./Flex"));

var _Wrapper = require("./Wrapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Grid___StyledFlex",
  componentId: "sc-1k1lwzx-0"
})(["display:grid;grid-template-columns:", ";grid-gap:", ";", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Grid(_ref) {
  var columnLayout = _ref.columnLayout,
      _ref$gridGap = _ref.gridGap,
      gridGap = _ref$gridGap === void 0 ? 0 : _ref$gridGap,
      cssProp = _ref.css,
      props = _objectWithoutProperties(_ref, ["columnLayout", "gridGap", "css"]);

  return /*#__PURE__*/_react["default"].createElement(_StyledFlex, _extends({}, props, {
    _css: columnLayout,
    _css2: (0, _Wrapper.resolveNumberOrString)(gridGap),
    _css3: cssProp
  }));
}

var _default = Grid;
exports["default"] = _default;